<template>
  <div class="list-box">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.keywords"
          style="width: 300px"
          placeholder="户名、银行账户、开户行、付款人手机号"
          clearable
          @clear="
            delete state.params.keywords;
            onLoad();
          "
          @paste.enter="$onKeywordsPaste($event, state.params)"
        ></el-input>
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
      <el-button
        type="primary"
        :icon="Plus"
        link
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
        v-if="$judge_auth('65')"
        >添加</el-button
      >
    </ul>
    <ul class="list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column label="状态" sortable="status">
          <template #default="{ row }">
            <text :style="{ color: row.status == 1 ? '#1e90ff' : '#f00' }">{{
              row.status == 1 ? "正常" : "停用"
            }}</text>
          </template>
        </el-table-column>
        <el-table-column prop="b2e_type" label="银企类型" />
        <el-table-column prop="name" label="户名" />
        <el-table-column prop="account" label="银行账户" />
        <el-table-column prop="bank" label="开户银行" />
        <el-table-column prop="opening_bank" label="开户行支行" />
        <el-table-column prop="phone" label="付款人手机号" />
        <el-table-column prop="cnaps" label="联行号" :formatter="$tab_TextFormat" />
        <el-table-column
          label="操作"
          width="220"
          align="center"
          fixed="right"
          className="tabBtn"
          v-if="$judge_auth('65')"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Edit"
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
            >
              编辑
            </el-button>
            <el-button
              type="danger"
              link
              icon="Delete"
              @click="onDelete(row.id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showInfo"
      :title="(state.selectId ? '修改' : '添加') + '付款账户'"
      @close="state.showInfo = false"
    >
      <c_Info
        @close="
          state.showInfo = false;
          onLoad();
        "
        :id="state.selectId"
        :withholding_agent_id="props.withholding_agent_id"
      ></c_Info>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  withholdingagent_bank_list,
  withholdingagent_bank_delete,
} from "@/http/withholdingagent";
import { confirm_func } from "@/utils/qFormat";

import c_Info from "./Info.vue";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  components: {
    c_Info,
  },
  props: {
    withholding_agent_id: Number,
  },
  setup(props) {
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.withholding_agent_id = props.withholding_agent_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      withholdingagent_bank_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //删除
    const onDelete = (id) => {
      confirm_func(withholdingagent_bank_delete, id, onLoad);
    };

    return {
      state,
      props,
      onLoad,
      onSortChange,
      onReset,
      onDelete,
    };
  },
};
</script>
<style scoped></style>
